var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 1.33337C4.32065 1.33337 1.33398 4.32004 1.33398 8.00004C1.33398 11.68 4.32065 14.6667 8.00065 14.6667C11.6807 14.6667 14.6673 11.68 14.6673 8.00004C14.6673 4.32004 11.6807 1.33337 8.00065 1.33337ZM7.33398 13.2867C4.70065 12.96 2.66732 10.72 2.66732 8.00004C2.66732 7.58671 2.72065 7.19337 2.80732 6.80671L6.00065 10V10.6667C6.00065 11.4 6.60065 12 7.33398 12V13.2867ZM11.934 11.5934C11.7607 11.0534 11.2673 10.6667 10.6673 10.6667H10.0007V8.66671C10.0007 8.30004 9.70065 8.00004 9.33398 8.00004H5.33398V6.66671H6.66732C7.03398 6.66671 7.33398 6.36671 7.33398 6.00004V4.66671H8.66732C9.40065 4.66671 10.0007 4.06671 10.0007 3.33337V3.06004C11.954 3.85337 13.334 5.76671 13.334 8.00004C13.334 9.38671 12.8007 10.6467 11.934 11.5934Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.8f4f5383c9271e1ae80c33336731124d.svg";
export { ForwardRef as ReactComponent };